import { api } from './api';

export const getChemicalNames = async (): Promise<string[]> => {
    try {
        const response = await api.get('/api/precursors/');
        return response.data.map((item: any) => item.name);
    } catch (error) {
        console.error('Ошибка при получении списка веществ:', error);
        return []; // Возвращаем пустой массив в случае ошибки
    }
};

export const getPrecursorChemicalNames = async (): Promise<string[]> => {
    try {
        const response = await api.get('/api/precursors/');
        return response.data.map((item: any) => item.name);
    } catch (error) {
        console.error('Ошибка при получении списка прекурсоров:', error);
        return []; // Возвращаем пустой массив в случае ошибки
    }
};

export const getStandardSampleNames = async (): Promise<string[]> => {
    try {
        const response = await api.get('/api/standard-samples/');
        return response.data.map((item: any) => item.name);
    } catch (error) {
        console.error('Ошибка при получении списка стандартных образцов:', error);
        return []; // Возвращаем пустой массив в случае ошибки
    }
}; 